import * as zod from 'zod';

export const CNCRunProgramVariables = zod.object({});

export type CNCRunProgramVariables = zod.infer<typeof CNCRunProgramVariables>;
